import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
  ) { }

  openDialog(componentName:any, height:any, width:any, dataModel:any, maxWidth: string = '95vw', maxHeight: string = '80vh') {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: false,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }

  openSocialBrand(componentName: any, height: any, width: any,data:any) {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data:data,

    });
}
openDialogBelowButton(
    componentName: any, 
    height: any, 
    width: any, 
    data: any, 
    targetElement?: HTMLElement,
    staffData?: any
) {
    let topPosition = '50%';
    let leftPosition = '50%';
    const dialogHeight = 200; 
    
    if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        if ((rect.bottom + dialogHeight) <= window.innerHeight) {
            topPosition = rect.bottom + 'px';
        } else {
            topPosition = (rect.top - dialogHeight) + 'px';
        }
        
        leftPosition = Math.min(
            rect.left,
            window.innerWidth - parseInt(width, 10)
        ) + 'px';
    }
    
    const dialogRef = this.dialog.open(componentName, {
        height: height,
        width: width,
        data: { ...data, staff: staffData },
        position: {
            top: topPosition,
            left: leftPosition
        },
        panelClass: 'attendance-dialog'
    });
    
    return dialogRef;
}
openCertificateDialog(componentName: any, height: any, width: any, dataModel: any,position :any) {
  return this.dialog.open(componentName, {
    width: width,
    height: height,
    data: dataModel,
    position : position,
    disableClose: true,
  });
}

  createLead(data:any){
    return this.http.post(
      environment.baseUrl+`crm/leads`,data
    )
  }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  openServiceDialog(componentName:any, height:any, width:any, maxWidth:any, dataModel:any, position: any = {right:'0px',top:'0px'}) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth:maxWidth,
      data: dataModel,
      disableClose: true,
     position: position,
    });
  }
  openServiceDialogMobile(componentName:any, height:any, width:any, maxWidth:any, dataModel:any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth:maxWidth,
      data: dataModel,
      disableClose: true,
    });
  }

  getLeadApis(businessId:any,pageNo:any,size:any,leadType:any){
    return this.http.get(
      environment.baseUrl+`crm/lead/v2?businessId=${businessId}&size=${size}&pageNo=${pageNo}&leadType=${leadType}`
    )
  }

  filterleadapi (payload:any){
    return this.http.put(
      environment.baseUrl+`crm/lead/v2/filter` , payload
    )
  }



  getLeadApiswithoutLeadType(businessId:any,pageNo:any,size:any, staffId: any = '' , status){
    let url = ""
    if(status.length > 0)
      url = url + `&status=${status}`
    return this.http.get(
      environment.baseUrl+`crm/lead/v2?businessId=${businessId}&size=${size}&pageNo=${pageNo}&staffId=${staffId}${url}`
    )
  }

  searchLeadApis(businessId:any,text:any,pageNo:any,size:any){
    return this.http.get(
      environment.baseUrl+`crm/leads?businessId=${businessId}&size=${size}&pageNo=${pageNo}&text=${text}`
    )
  }

  searchStudentList(businessId:any,searchText:any){
    return this.http.put(
      environment.baseUrl+`crm/leads/search?searchText=${searchText}&businessId=${businessId}` , ''
    )
  }
  searchLeadsCustomers(businessId:any,pageNo:any,size:any,leadType:any,searchText:any){
    return this.http.get(
      environment.baseUrl+`crm/lead/v2?businessId=${businessId}&pageNo=${pageNo}&size=${size}&leadType=${leadType}&text=${searchText}`
    )
  }
  deleteContact(id:any){
    return this.http.delete(
      environment.baseUrl+`crm/leads?leadId=${id}`
    )
  }

  getLeadTimeline(leadId:any , type:any){
    return this.http.get(
      environment.baseUrl+`crm/leads/timeline?leadId=${leadId}&type=${type}`
    )
  }
  getLeadById(leadId:any){
    return this.http.get(
      environment.baseUrl+`crm/leads/get-one?leadId=${leadId}`
    )
  }

  updateLead(data:any){
    return this.http.put(
      environment.baseUrl+`crm/leads`,data
    )
}

changeLeadStatus(leadStatus:any,leadId:any,isDeleted:any){
  return this.http.post(
    environment.baseUrl+`crm/leads/action?leadStatus=${leadStatus}&leadId=${leadId}&isDeleted=${isDeleted}`,{}
  )
}

openBottomSheet(componentName: any,data:any){
  return this. _bottomSheet.open(componentName, {
    data:data,

  });
}

// notes module
listNotes(leadId : any , recentFirst:any){
  return this.http.get(
    environment.baseUrl+`crm/notes?leadId=${leadId}&recentFirst=${recentFirst}`
  )
}
createNotes(data : any){
  return this.http.post(
    environment.baseUrl+`crm/notes/create`,data
  )
}
updateNotes(data : any){
  return this.http.put(
    environment.baseUrl+`crm/notes/update`,data
  )
}
deleteNotes(noteId:any){
  return this.http.delete(
    environment.baseUrl+`crm/notes/delete/${noteId}`
  )}

// attachments module
listAttachments(leadId :any){
  return this.http.get(
    environment.baseUrl+`crm/attachment?leadId=${leadId}`
  )
}
createAttachment(data :any){
  return this.http.post(
    environment.baseUrl+`crm/attachment/create`,data
  )
}
deleteAttachment(attachmentId:any){
  return this.http.delete(
    environment.baseUrl + `crm/attachment/delete/${attachmentId }`
  )
  }

  updateAttachment(data:any){
    return this.http.put(
      environment.baseUrl + `crm/attachment/update`,data
    )
  }

  viewAttachments(attachmentId:any){
    return this.http.get(
      environment.baseUrl + `crm/attachment/get/${attachmentId }`
    )
  }

  searchAttachments(leadId:any , text:any){
    return this.http.get(
      environment.baseUrl + `crm/attachment/search/${leadId}?text=${text}`
    )
  }

// calls module
listCalls(businessId: any, pageNo: any, size: any, callStatus: any, start?: any, end?: any) {
  let apiUrl = environment.baseUrl + `crm/call?businessId=${businessId}&pageNo=${pageNo}&size=${size}&callStatus=${callStatus}`;
  
  if (start && end) {
    apiUrl += `&startDate=${start}&endDate=${end}`;
  }
  
  return this.http.get(apiUrl);
}
CallsListByLeadId(leadId:any,pageNo:any,size:any,callStatus:any){
  return this.http.get(
    environment.baseUrl + `crm/call/bylead?leadId=${leadId}&pageNo=${pageNo}&size=${size}&callStatus=${callStatus}`
  )
}
searchCalls(businessId:any,pageNo:any,size:any,callStatus:any,searchText:any){
  return this.http.get(
    environment.baseUrl+`crm/call?businessId=${businessId}&pageNo=${pageNo}&size=${size}&callStatus=${callStatus}&text=${searchText}`
  )
}
createCall(data:any){
  return this.http.post(
    environment.baseUrl+`crm/call/create`,data
  )
}
editCall(data:any){
  return this.http.put(
    environment.baseUrl+`crm/call/update`,data
  )
}
callFilter(businessId:any, pageNo:any,size:any , data:any){
  return this.http.put(
    environment.baseUrl+`crm/call/filter/${businessId}?pageNo=${pageNo}&size=${size}`,data
  )
}
changeCallStatus(callId:any, status:any){
  return this.http.put(
    environment.baseUrl+`crm/call/change/status?callId=${callId}&callStatus=${status}`,{}
  )
}
getCallDetails(callId:any){
  return this.http.get(
    environment.baseUrl+`crm/call/${callId}`
  )
}
getNotesByCallId(callId:any){
  return this.http.get(
    environment.baseUrl+`crm/call/taskDoc/${callId}`
  )
}
createNotesByCallId(callId:any, data:any){
  return this.http.post(
    environment.baseUrl+`crm/call/notes/create/${callId}`,data
  )
}
editNotesByCallId(callId:any, data:any){
  return this.http.put(
    environment.baseUrl+`crm/call/notes/update/${callId}`,data
  )
}
deleteNotesByCallId(callId:any,noteId:any){
  return this.http.delete(
    environment.baseUrl+`crm/call/notes/delete/${callId}?notesId=${noteId}`
  )
}

deleteNotesByTaskId(taskId:any,noteId:any){
  return this.http.delete(
    environment.baseUrl+`crm/task/notes/delete/${taskId}?notesId=${noteId}`
  )
}

deleteCallActivityCallId(callId:any){
  return this.http.delete(
    environment.baseUrl + `crm/call/callActivity/delete/${callId }`
  )
}
// activity api

activityList(leadId:any){
  return this.http.get(
    environment.baseUrl+`crm/activity?leadId=${leadId}`
  )
}

activityStatus(leadId:any, pageNo:any , size:any , typeType:any){
  return this.http.put(
    environment.baseUrl + `crm/activity/status/${leadId}?pageNo=${pageNo}&size=${size}&typeType=${typeType}`,{}
  )
}

//meetings module
createMeeting(data:any){
  return this.http.post(
    environment.baseUrl+`crm/meeting/create`,data
  )
}

listMeeting(businessId: any, pageNo: any, size: any, meetingStatus: any, start?: any, end?: any) {
  let apiUrl = environment.baseUrl + `crm/meeting?businessId=${businessId}&pageNo=${pageNo}&size=${size}&meetingStatus=${meetingStatus}`;
  
  if (start && end) {
    apiUrl += `&startDate=${start}&endDate=${end}`;
  }
  
  return this.http.get(apiUrl);
}
listMeetingByLeadId(leadId:any, pageNo:any, size:any){
  return this.http.get(
    environment.baseUrl + `crm/meeting/withLead/${leadId}?page=${pageNo}&size=${size}`
  )
}

addParticipantsByMeetId(meetId:any,data:any){
  return this.http.put(
    environment.baseUrl+`crm/meeting/participants/${meetId}`,data
  )
}

searchMeeting(businessId:any ,pageNo:any , size:any, meetingStatus:any,text:any){
  return this.http.get(
    environment.baseUrl + `crm/meeting?businessId=${businessId}&pageNo=${pageNo}&size=${size}&meetingStatus=${meetingStatus}&text=${text}`
  )
}

getMeetingDetails(meetingId:any){
  return this.http.get(
    environment.baseUrl + `crm/meeting/${meetingId}`
  )
}
editMeeting(data:any){
  return this.http.put(
    environment.baseUrl+`crm/meeting/update`,data
  )
}
createNotesByMeetingId(meetId:any , data:any){
  return this.http.post(
    environment.baseUrl+`crm/meeting/notes/create/${meetId}`,data
  )
}
editNotesByMeetingId(meetId:any , data:any){
  return this.http.put(
    environment.baseUrl+`crm/meeting/notes/update/${meetId}`,data
  )
}

editAttachmentByMeetingId(meetId:any , data:any){
  return this.http.put(
    environment.baseUrl + `crm/meeting/attachments/update/${meetId}`, data
  )
}

getNotesByMeetingId(meetId:any){
  return this.http.get(
    environment.baseUrl + `crm/meeting/taskDoc/${meetId}`
  )
}


createAttachmentsByMeetingId(meetId:any , data:any){
  return this.http.post(
    environment.baseUrl + `crm/meeting/attachment/create/${meetId}`,data
  )}

  deleteAttachmentsByMeetingId(meetId:any , attachmentId:any){
    return this.http.delete(
      environment.baseUrl + `crm/meeting/attachment/delete/${meetId}?attachmentId=${attachmentId}`
    )
  }

  deleteMeeting(meetingId:any){
    return this.http.delete(
      environment.baseUrl + `crm/meeting/delete/${meetingId}`
    )
  }

  deleteMeetingByCallId(meetId:any,notesId:any){
    return this.http.delete(
      environment.baseUrl + `crm/meeting/notes/delete/${meetId}?notesId=${notesId}`
    )
  }

  meetingFilter(businessId  :any , meetingStatus:any , pageNo:any ,size:any ){
    return this.http.put(
      environment.baseUrl + `crm/meeting/filter/${businessId}?meetingStatus=${meetingStatus}&pageNo=${pageNo}&size=${size}`,{}
    )
  }

  meetingLeadFilter(leadId:any, meetingStatus:any,pageNo:any, size:any){
    return this.http.put(
      environment.baseUrl + `crm/meeting/filter/lead/${leadId}?meetingStatus=${meetingStatus}&pageNo=${pageNo}&size=${size}`,{}
    )

  }



// emails module
listEmails(leadId:any){
  return this.http.get(
    environment.baseUrl+`crm/mail?leadId=${leadId}`,
  )
}
createEmail(data : any){
  return this.http.post(
    environment.baseUrl+`crm/mail/create`,data
  )
}
editEmail(data:any){
  return this.http.put(
    environment.baseUrl+`crm/mail/update`,data
  )
}
viewEmailDetails(mailId:any){
  return this.http.get(
    environment.baseUrl+`crm/mail/get/${mailId}`
  )
}
deleteEmail(id:any){
  return this.http.delete(
    environment.baseUrl+`crm/mail/delete/${id}`
  )
}

// tasks module

listTasks(businessId: any, pageNo: any, size: any, taskStatus: any, staffId: any, start?: any, end?: any) {
  let apiUrl = environment.baseUrl + `crm/task?businessId=${businessId}&pageNo=${pageNo}&size=${size}&taskStatus=${taskStatus}`;
  
  if (staffId && staffId !== '') {
    apiUrl += `&staffId=${staffId}`;
  }
  
  if (start && end) {
    apiUrl += `&startDate=${start}&enddate=${end}`;
  }
  
  return this.http.get(apiUrl);
}
createTask(data:any){
  return this.http.post(
    environment.baseUrl+`crm/task/create`,data
  )
}
editTask(data:any){
  return this.http.put(
    environment.baseUrl+`crm/task/update`,data
  )
}
getTaskDetails(taskId:any){
  return this.http.get(
    environment.baseUrl+`crm/task/getById/${taskId}`
  )
}

getTaskDocsByTaskId(taskId:any){
  return this.http.get(
    environment.baseUrl+`crm/task/taskDoc/${taskId}`
  )
}
createNotesByTaskId(taskId:any, data:any){
  return this.http.post(
    environment.baseUrl+`crm/task/notes/create/${taskId}`,data
  )
}
updateNotesByTaskId(taskId:any, data:any){
  return this.http.put(
    environment.baseUrl+`crm/task/notes/update/${taskId}`,data
  )
}
editNotesByTaskId(taskId:any, data:any){
  return this.http.put(
    environment.baseUrl+`crm/task/notes/update/${taskId}`,data
  )
}
createAttachmentsByTaskId(taskId:any,data:any){
  return this.http.post(
    environment.baseUrl+`crm/task/attachment/create/${taskId}`,data
  )
}
editAttachmentsByTaskId(taskId:any, data:any){
  return this.http.put(
    environment.baseUrl+`crm/task/attachments/update/${taskId}`,data
  )
}

searchTasks(businessId:any ,pageNo:any , size:any, taskStatus:any,text:any){
  return this.http.get(
    environment.baseUrl + `crm/task?businessId=${businessId}&pageNo=${pageNo}&size=${size}&taskStatus=${taskStatus}&text=${text}`
  )
}

deleteTask(taskId:any){
  return this.http.delete(
    environment.baseUrl+`crm/task/delete/${taskId}`
  )
}

changeTaskStatus(taskId:any,taskStatus:any ){
  return this.http.put(
    environment.baseUrl+`crm/task/change/status?taskId=${taskId}&taskStatus=${taskStatus}`,{}
  )
}
getTasksByLeadId(leadId:any){
  return this.http.get(
    environment.baseUrl+`crm/task/getByLeadId/${leadId}`
  )
}

deleteAttachmentByTastId(taskId:any ,attachmentId :any){
  return this.http.delete(
    environment.baseUrl + `crm/task/attachment/delete/${taskId}?attachmentId=${attachmentId}`
  )
}

taskLeadOpenClose(page:any ,size:any ,type:any , leadId:any, queryType:any){
  return this.http.get(
    environment.baseUrl + `crm/task/openclose?page=${page}&size=${size}&type=${type}&uuId=${leadId}&queryType=${queryType}`
  )
}

taskBusinessOpenClose(page:any,size:any,type:any){

}



taskFilter(page:any ,size:any , data:any ){
  return this.http.put(
    environment.baseUrl + `crm/task/filter?page=${page}&size=${size}`,data
  )
}

// update lead status
updateLeadStatus(leadId:any,status:any){
  return this.http.put(
    environment.baseUrl+`crm/lead/v2/convert?leadId=${leadId}&leadType=${status}`,{}
  )
}
// leads filter

openFilterLead(data:any){
  return this.http.put(
    environment.baseUrl +`crm/leads/filter`,data
  )
}
//activity filter
activityFilter(leadId:any,type:any){
  return this.http.get(
    environment.baseUrl + `crm/activity/list?leadId=${leadId}&type=${type}`
  )
}

// excel for lead listing
genrateLeadExcel(data:any,businessId:any){
  return this.http.post(
    environment.baseUrl + `crm/leads/uploadExcel?businessId=${businessId}`,data
  )
}

// sub industry
getSubIndustries(page:number,size:number){
  return this.http.get(
    environment.serverIp + `master/business/industry/sub?size=${size}&page=${page}`
  )
}

// getDashboardData(id: string, startDate?: string, endDate?: string,leadXAxisType?:any ) {
//   return this.http.get(
//     environment.baseUrl + `crm/dashboard?businessId=${id}&startDate=${startDate}&endDate=${endDate}&leadXAxisType=${leadXAxisType}`
//   )
// }
getDashboardData(id: string, startDate?: string, endDate?: string, leadXAxisType?: any) {
  let url = environment.baseUrl + `crm/dashboard/v2?businessId=${id}`;

  if (startDate && endDate && leadXAxisType) {
    url += `&startDate=${startDate}&endDate=${endDate}&leadXAxisType=${leadXAxisType}`;
  }

  return this.http.get(url);
}



//Fields Module

createfields(payload,formName: string) {
  return this.http.post(
    environment.baseUrl+ `crm/fields?fieldCategory=${formName}`, payload
  )
}

updatefields(payload,formName: string) {
  return this.http.put(
    environment.baseUrl+ `crm/fields?fieldCategory=${formName}`, payload
  )
}



getFieldsApi(businessId:any,pageNo:any,size:any,status:any,formName:any){
  let url = ""
  if(status != null)
    url = url + `&status=${status}`
  return this.http.get(
    environment.baseUrl+`crm/fields?businessId=${businessId}&size=${size}&pageNo=${pageNo}&fieldCategory=${formName}${url}`
  )
}


getfieldgroupsapi(businessId:any) {
  return this.http.get(
    environment.baseUrl+ `crm/fields/fieldgroup?businessId=${businessId}`
  )
}

searchfieldgroup(payload:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/fieldgroup/filter`, payload
  )
}

getFieldsShowInForm(businessId:any,formName:any){
  return this.http.get(
    environment.baseUrl+`crm/fields?businessId=${businessId}&status=true&showInForm=ENQUIRY&isPagination=false&fieldCategory=${formName}`
  )
}

getAllCustomFields(businessId:any,searchText:any,fieldCategory:any){
  return this.http.get(
    environment.baseUrl+`crm/fields?businessId=${businessId}&status=true&searchText=${searchText}&isPagination=false&fieldCategory=${fieldCategory}`
  )
}

changeFieldRequiredStatus(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

changeShowInEnquiryFieldStatus(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

viewregistrationsidepanel(id:any) {
  return this.http.get(
    environment.baseUrl+`crm/registration/${id}?examData=true`
  )
}

changeShowInRegistrationFieldStatus(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

changeShowInAdmissionFieldStatus(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

changeFieldStatus(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

searchFields(pageNo:any,size:any,searchText:any,fieldCategory:any , businessId : any,status:any){
  let url = ""
   if(status != null)
    url = url + `&status=${status}`
  return this.http.get(
    environment.baseUrl+`crm/fields?businessId=${businessId}&pageNo=${pageNo}&size=${size}&searchText=${searchText}&fieldCategory=${fieldCategory}${url}`
  )
}


deleteField(fieldId:any,fieldCategory:any){
  return this.http.delete(
    environment.baseUrl+`crm/fields?id=${fieldId}&fieldCategory=${fieldCategory}`,{}
  )
}

getFieldGroupApi(businessId:any){
  return this.http.get(
    environment.baseUrl+`crm/fields/fieldgroup?businessId=${businessId}`
  )
}

getFieldType() {
  return this.http.get(
    environment.baseUrl + `crm/fields/fieldTypes`
  )
}

putFieldGroupApi(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/fieldgroup/filter`, data
  )
}

getfieldsFieldGroupApi(fieldGroupId:any,fieldCategory:any){
  return this.http.get(
    environment.baseUrl+`crm/fields/fieldGroupId?fieldGroupId=${fieldGroupId}&fieldCategory=${fieldCategory}`
  )
}


createFieldGroup(payload:any){
  return this.http.post(
    environment.baseUrl+`crm/fields/fieldgroup`,payload
  )
}
updateFieldGroup(payload:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/fieldgroup`,payload
  )
}

changeFieldGroupStatus(status:any,id:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/fieldGroup/toggle?status=${status}&id=${id}`,{}
  )
}

deleteFieldGroup(fieldGroupId:any) {
  return this.http.delete(
    environment.baseUrl+`crm/fields/fieldgroup?id=${fieldGroupId}`
  )
}


deleteFielParentGroup(fieldGroupId:any) {
  return this.http.delete(
    environment.baseUrl+`crm/fields/fieldParentGroup?id=${fieldGroupId}`
  )
}

getFieldParentGroups(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/fieldParentGroup/filter`, data
  )
}

createFieldParentGroup(payload:any){
  return this.http.post(
    environment.baseUrl+`crm/fields/fieldParentGroup`,payload
  )
}

changeFieldParentGroupStatus(status:any,fieldGroupId:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/fieldParentGroup/toggle?status=${status}&id=${fieldGroupId}`,{}
  )
}


getDataSourceTypesApi(){
  return this.http.get(
    environment.baseUrl+`crm/fields/dataSourceTypes`
  )
}


//Templates
getTemplates(businessId:any,pageNo:any,size:any,formCategory:any){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${businessId}&size=${size}&pageNo=${pageNo}&formCategory=${formCategory}`
  )
}

getCommunicationTemplate(businessId,category,templateType){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${businessId}&status=true&formCategory=${category}&pageNo=0&size=100&type=${templateType}`
  )
}

getSuccessTemplates(businessId:any,pageNo:any,size:any,formCategory:any,type:any,status:any){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${businessId}&size=${size}&pageNo=${pageNo}&formCategory=${formCategory}&type=${type}&status=${status}`
  )
}

changeTemplateStatus(status:any,templateId:any,category:any){
  return this.http.put(
    environment.baseUrl+`crm/templates/toggle/status?status=${status}&id=${templateId}&category=${category}`,{}
  )
}

changeCommunicationTemplateStatus(status:any,templateId:any){
  return this.http.put(
    environment.baseUrl+`crm/templates/toggle?status=${status}&id=${templateId}`,{}
  )
}
deleteTemplate(templateId:any){
  return this.http.delete(
    environment.baseUrl+`crm/templates?id=${templateId}`,{}
  )
}

searchTemplates(businessId:any,pageNo:any,size:any,searchText:any,formCategory:any){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${businessId}&pageNo=${pageNo}&size=${size}&searchText=${searchText}&formCategory=${formCategory}`
  )
}
searchCommunicationTemplates(businessId:any,pageNo:any,size:any,searchText:any,formCategory:any,type:any,status:any){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${businessId}&pageNo=${pageNo}&size=${size}&searchText=${searchText}&formCategory=${formCategory}&type=${type}&status=${status}`
  )
}
createTemplate(data:any){
  return this.http.post(
    environment.baseUrl+`crm/templates`,data
  )
}
updateTemplate(data:any){
  return this.http.put(
    environment.baseUrl+`crm/templates`,data
  )
}

getSelectedListFields(bId:any,showInErp:any,formName:any){
  return this.http.get(
    // environment.baseUrl+`crm/fields?showInErp=${showInErp}&isPagination=false`
    // environment.baseUrl+`crm/fields?businessId=${bId}&showInErp=${showInErp}&isPagination=false`
    environment.baseUrl+ `crm/fields?businessId=${bId}&status=true&showInErp=${showInErp}&isPagination=false&fieldCategory=${formName}`
  )
}

updateenquiryformfields(fieldId:any,formName:any,isSelected:boolean ) {
  return this.http.put(
    environment.baseUrl+`crm/fields/update-selected?fieldId=${fieldId}&fieldCategory=${formName}&isSelected=${isSelected}`,''
  )}

getAllFieldsByBusinessId(bId:any){
  return this.http.get(
    environment.baseUrl+`crm/fields?businessId=${bId}&showInErp=ENQUIRY&isPagination=false`
  )
}

getAllGrades(){
  return this.http.get(
    environment.baseUrl+`crm/master/getAllGradeMasterDetails`
  )
}

createacademicyears(payload: any) {
  return this.http.post(
    environment.baseUrl+ `crm/master/saveOrUpdateAcademicYearMaster` , payload
  )
}

getAllAcademicYears(){
  return this.http.get(
    environment.baseUrl+`crm/master/getAllAcademicYearMasterDetails`
  )
}

activeInactiveFieldsForList(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/update-selected?fieldId=${data.fieldId}&fieldCategory=${data.fieldCategory}&isSelected=${data.isSelected}`,data
  )
}

getWebsiteTemplate(templateId: string) {
  return this.http.get(environment.baseUrl + `business/v3/website/${templateId}/pages/list`);
}

saveTemplatePage(data: any){
  return this.http.post(
    environment.baseUrl + `business/v3/create/website`, data
  )
}

updateItemInWebForm(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

updateIsRequiredInWebFormApi(data:any){
  return this.http.put(
    environment.baseUrl+`crm/fields/toggle`,data
  )
}

contctUsForm(data:any){
  return this.http.post(
    environment.baseUrl+`business/contact`,data
  )
}

getActiveTemplate(bId:any,formCategory:any){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${bId}&status=true&formCategory=${formCategory}`
  )
}

getActiveTemplate_1(bId:any,formCategory:any){
  return this.http.get(
    environment.baseUrl+`crm/templates?businessId=${bId}&status=true&formCategory=${formCategory}&type=SUCCESS_TEMPLATE`
  )
}

sendRegistrationLink(data:any){
  return this.http.put(
    environment.baseUrl+`crm/leads/email?leadId=${data.leadId}&templateId=${data.templateId}`,data
  )
}

//Subscription:
getSubscriptionDashboard(payload: any) {
  let url = `${environment.baseUrl}crm/subscription/${payload.businessId}/dashboard?`;
  if (payload.startDate) {
    url += `&startDate=${payload.startDate}`;
  }
  if (payload.endDate) {
    url += `&endDate=${payload.endDate}`;
  }
  if (payload.gradeId) {
    if (Array.isArray(payload.gradeId)) {
      url += `&gradeId=${payload.gradeId.join(',')}`;
    } else {
      url += `&gradeId=${payload.gradeId}`;
    }
  }
  return this.http.put(url, {});
}

createSubscriptionType(payload)
{
  return this.http.post(
    environment.baseUrl + `crm/subscription/type` , payload
  )
}

deleteSubscriptionType(id : any)
{
  return this.http.delete
  ( environment.baseUrl + `crm/subscription/type?id=${id}`)
}

getAllSubscriptionType(businessId : any,pageNo : any,size : any,searchText : any, isDeleted : any)
{
  let url = ""
  if(searchText.length > 2)
     url = url + `&searchText=${searchText}`
  if(!isDeleted)
    url = url + `&isDeleted=${isDeleted}`
  return this.http.get(
    environment.baseUrl + `crm/subscription/type?businessId=${businessId}&pageNo=${pageNo}&size=${size}${url}`
  )
}

getSubscribedDateBySubscriptionId(data:any){
  return this.http.put(
    environment.baseUrl+`crm/subscription/plan/student/list`,data
  )
}

getsubscriptionsbasedongradeid(businessId: any,gradeId: any) {
  return this.http.get(
    environment.baseUrl+`crm/subscription/plan/list?businessId=${businessId}&gradeId=${gradeId}&status=true&isDeleted=false`
  )
}

getAllActiveSubscriptionTypes(businessId : any,pageNo : any,size : any,searchText : any, isDeleted : any,status : any)
{
  let url = ""
  if(searchText.length > 2)
     url = url + `&searchText=${searchText}`
  if(!isDeleted)
    url = url + `&isDeleted=${isDeleted}`
  return this.http.get(
    environment.baseUrl + `crm/subscription/type?businessId=${businessId}&pageNo=${pageNo}&size=${size}&status=${status}${url}`
  )
}

createSubscription(payload : any)
{
  return this.http.post(
    environment.baseUrl + `crm/subscription/plan` , payload
  )
}

getAllSubscription(
  businessId: any,
  pageNo: any,
  pageSize: any,
  isDeleted: boolean,
  searchText: string = '',
  subscriptionType?: string
) {
  let queryParams = '';

  if (searchText && searchText.length > 2) {
    queryParams += `&searchText=${encodeURIComponent(searchText)}`;
  }

  if (subscriptionType) {
    queryParams += `&subscriptionType=${encodeURIComponent(subscriptionType)}`;
  }

  const url = `${environment.baseUrl}crm/subscription/plan?businessId=${businessId}&pageNo=${pageNo}&size=${pageSize}&isDeleted=${isDeleted}${queryParams}`;

  return this.http.get(url);
}

getSingleSubscription(subscriptionId:any){
  return this.http.get(
    environment.baseUrl+`crm/subscription/plan/id?subscriptionId=${subscriptionId}&businessId=${localStorage.getItem('businessId')}`
  )
}

deleteSubscription(id : any)
{
  return this.http.delete(
    environment.baseUrl + `crm/subscription/plan?id=${id}`
  )
}

toogleSubscription(id,status)
{
  return this.http.put(
    environment.baseUrl + `crm/subscription/plan?id=${id}&status=${status}`,''
  )
}

toogleSubscriptionType(id,status)
{
  return this.http.put(
    environment.baseUrl + `crm/subscription/type?id=${id}&status=${status}`,''
  )
}

filterFields(bId,filterStatus,pageNo,size,fieldCategory){
  return this.http.get(
    environment.baseUrl+ `crm/fields/filter/status?businessId=${bId}&status=${filterStatus}&page=${pageNo}&size=${size}&fieldcategory=${fieldCategory}`
  )
}


getFilterLeadList(data:any){
  return this.http.put(
    environment.baseUrl+`crm/leads/get/lead/data`,data
  )
}

getLeadStatusMaster(){
  return this.http.get(
    environment.baseUrl+`crm/master/lead-status/business?businessId=${localStorage.getItem('businessId')}`
  )
}

//subscribers apis
 updateSubscribers(payload){
  return this.http.put(
    environment.baseUrl+`crm/subscriber`, payload
  )
 }
 getSubscriberList(payload){
  return this.http.put(
    environment.baseUrl+`crm/subscriber/get/all`, payload
  )
 }

 addSubscriber(payload){
  return this.http.post(
    environment.baseUrl+`crm/subscriber`, payload
  )
 }

 updateSubscriber(payload){
  return this.http.put(
    environment.baseUrl+`crm/subscriber`, payload
  )
 }
 filterSubscribers(payload){
  return this.http.put(
    environment.baseUrl+`crm/subscriber/get/all`, payload
  )
 }
 deleteSubscriber(payload){
  return this.http.delete(
    environment.baseUrl+`crm/subscriber?id=${payload}`, {}
  )
 }

 getSingleStudentDetails(id:any){
  return this.http.get(
    environment.baseUrl+`crm/registration/student/${id}`, {}
  )
 }

  //Academics Module
  //DTR
  getAllDtr(payload){
    return this.http.put(
      environment.baseUrl + `crm/dtr/filter`, payload
    )
  }
  
  generateDtr(payload){
    return this.http.post(
      environment.baseUrl + `crm/dtr`, payload
    )
  }
  
  deleteDtr(payload){
    return this.http.delete(
      environment.baseUrl + `crm/dtr?id=${payload}`,{}
    )
  }

  updateDtr(payload){
    return this.http.put(
      environment.baseUrl + `crm/dtr`, payload
    )
  }

  changeDtrStatus(payload) {
  let url = environment.baseUrl + `crm/dtr/status?id=${payload.id}&status=${payload.status}`;
  
  if (payload.feedback) {
    url += `&feedback=${encodeURIComponent(payload.feedback)}`;
  }

  return this.http.put(url, {});
}
//gate-pass apis
 getGPList(payload){
    return this.http.put(
      environment.baseUrl + `crm/gate-pass/filter`, payload
    )
 }

 getGPDashoard(businessId:any,startDate?:any,endDate?:any){
  let url = environment.baseUrl+`crm/gate-pass/dashboard?businessId=${businessId}`
  if(startDate){
    url += `&startDate=${startDate}`
  }
  if(endDate){
    url +=`&endDate=${endDate}`
  }
  return this.http.put(url,{})
 }

 createGatePass(payload){
   return this.http.post(
      environment.baseUrl + `crm/gate-pass`, payload
    )
 }

 changeGPStatus(payload){
    return this.http.put(
      environment.baseUrl + `crm/gate-pass/status`, payload
    )
 }

 getGPDatabyId(id:any){
    return this.http.get(
      environment.baseUrl + `crm/gate-pass/${id}`
    )
 }

 downloadGPList(payload){
   return this.http.put(
      environment.baseUrl + `crm/gate-pass/export`, payload,
       { responseType: 'blob' } 
    )
 }
  //Student Attendance v2 APIs Changes

  downloadStudentAttendance(id:any, date?:any){
    return this.http.get(
      environment.baseUrl +`crm/student-attendance/${id}/export-template?date=${date}`,
          { responseType: 'blob' } 
    )
  }
  getStudentList(queryParam){
    return this.http.get(
      environment.baseUrl + `crm/registration/ay/studentList?businessId=${queryParam.businessId}&gradeId=${queryParam.gradeId}&sectionId=${queryParam.sectionId}&academicYearId=${queryParam.academicYearId}`
    )
  }

  markStudentAttendance(payload){
    return this.http.post(
      environment.baseUrl + `crm/student-attendance/${payload.businessId}/mark`, payload
    )
  }

  getAttendanceList(payload){
    return this.http.put(
      environment.baseUrl + `crm/student-attendance/filter`, payload
    )
  }
  
  getAttendanceListByDate(payload){
    return this.http.put(
      environment.baseUrl + `crm/student-attendance/filter/count`, payload
    )
  }

  getStudentDetailsByDate(payload){
    return this.http.get(
      environment.baseUrl + `crm/student-attendance/remark-data?studentId=${payload.studentId}&date=${payload.date}`
    )
  }

  updateStatusRemarks(payload){
    return this.http.patch(
      environment.baseUrl + `crm/student-attendance/student-remark`, payload
    )   
  }

  isMarkedAttendance(payload){
    return this.http.put(
      environment.baseUrl + `crm/student-attendance/marking-status?gradeId=${payload.gradeId}&sectionId=${payload.sectionId}&date=${payload.date}`,{}
    )
  }
  downloadAttendanceAllGrades(businessId: any, payload: any) {
  return this.http.put(
    environment.baseUrl + `crm/student-attendance/${businessId}/download/class`,
    payload,
    { responseType: 'blob' } 
  );
}
 getHomeDashboardData(payload){
    return this.http.put(
      environment.baseUrl + `crm/registration/home-dashboard`, payload
    )   
  }
   getStudentBirthdayList(businessId: any) {
  let url = `${environment.baseUrl}crm/registration/birthday-list?businessId=${businessId}`;
  return this.http.get(url);
}

timelineEvent = new EventEmitter<any>();
removeListContactColumn = new EventEmitter<any>();
editContactEvent = new EventEmitter<any>();
deleteContactEvent = new EventEmitter<any>();
addOrRemoveItemFromWebForm = new EventEmitter<any>();
updateIsRequiredInWebForm = new EventEmitter<any>();
sendRegistrationLinkEvent = new EventEmitter<any>();
// customFieldPositionLead = new EventEmitter<any>();
crmSaveOption = new EventEmitter<any>();
gotodashboard = new EventEmitter<any>();
showEnquiryFormFields = new EventEmitter<any>();
emailmeetinglead = new EventEmitter<any>();
ispaymentdone = new EventEmitter<any>();
iscmis = new EventEmitter<any>();
}

